import React from "react";
import {
  BrowserRouter as Router,
  Routes, Route, Navigate,
}
  from "react-router-dom";

import AppLayout from "./layout/AppLayout";
import Login from "./pages/Login/Login";
import Applications from "./pages/Applications/Applications";
import ApplicationReview from "./pages/ApplicationReview/ApplicationReview";
import Analytics from "./pages/Analytics/Analytics";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { ReviewProvider } from "./context/ReviewContext";
import { AuthProvider } from "./context/AuthProvider";
import PublicRoute from "./components/auth/PublicRoute";

const App = () => {
  return (
    <ReviewProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Route for Login */}
            <Route
              path="/"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />

            {/* Protected Routes with AppLayout */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              {/* Dashboard Routes */}
              <Route
                path="dashboard"
                element={<Navigate to="/dashboard/open-applications" replace />}
              />
              <Route
                path="dashboard/open-applications"
                element={<Applications key="open" status="open" />}
              />
              <Route
                path="dashboard/closed-applications"
                element={<Applications key="closed" status="closed" />}
              />
              <Route path="dashboard/analytics" element={<Analytics />} />

              {/* Review Route */}
              <Route
                path="review"
                element={<ApplicationReview />}
              />
            </Route>

            {/* Catch-All Route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ReviewProvider>
  );
};

export default App;

